// Angular Imports
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// This Module's Components
import { IndentLookupComponent } from './indent-lookup.component';
import { BizDatatableModule } from '../biz-datatable/biz-datatable.module';
import { PagesContainersModule } from '../../../../../containers/pages/pages.containers.module';
import { BizDropdownModule } from '../biz-dropdown/biz-dropdown.module';

@NgModule({
    imports: [
        FormsModule, ReactiveFormsModule, CommonModule, BizDatatableModule, PagesContainersModule, BizDropdownModule
    ],
    declarations: [
        IndentLookupComponent,
    ],
    exports: [
        IndentLookupComponent,
    ]
})
export class IndentLookupModule {

}
